
export enum DeliveredInvoiceTypeEnum {
  Pending = 0,
  DeliveredKitchen = 1,
  DeliveredCustomer = 2
}
